<template>
    <div id="app">
        <component v-bind:is="layout"></component>
        <CookieConsent />
    </div>
</template>

<script setup>
import AppLayout from '@/layouts/app-layout'
import AuthLayout from '@/layouts/auth-layout'
import EmptyLayout from '@/layouts/empty-layout'
import CookieConsent from './CookieConsent.vue'

const layouts = {
    app: AppLayout,
    auth: AuthLayout,
    empty: EmptyLayout,
}

import { computed } from 'vue'

import { useRoute } from 'vue-router/composables'

const route = useRoute()
const layout = computed(
    () => layouts[route.matched.reduceRight((a, c) => a ?? c.meta?.layout, null) ?? 'empty'] || EmptyLayout
)
</script>
<style src="@/css/site.css" />
